// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chip_chip__8iq2E {
  display: inline-block;
  background-color: #dedede;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Chip_chip__8iq2E + .Chip_chip__8iq2E {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Chip/Chip.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;AAAE;EACE,gBAAA;AAEJ","sourcesContent":[".chip {\n  display: inline-block;\n  background-color: #dedede;\n  border-radius: 16px;\n  padding: 6px 12px;\n  font-size: 12px;\n  line-height: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  & + .chip {\n    margin-left: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `Chip_chip__8iq2E`
};
export default ___CSS_LOADER_EXPORT___;
